import(/* webpackMode: "eager" */ "/vercel/path0/app/legal/terms/page.tsx");
